import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import * as types from '@/store/types'
import Config from '@/config'
import Brand from '@/config/brand.js'
import storage from '@/function/storage.js'
import http from '@/http'

Vue.use(Router)

let children = [{
		path: '/',
		name: 'dashboard',
		meta: {
			title: '首页',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/home/dashboard.vue'], resolve),
	}, {
		path: '/testcenter',
		name: 'testcenter',
		meta: {
			title: '题库',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/testExam/TestCenter.vue'], resolve),
	}, {
		path: '/onlinejudge',
		name: 'onlinejudge',
		meta: {
			title: 'OJ题库',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/judger/OnlineJudge.vue'], resolve),
	}, {
		path: '/testPracticeList',
		name: 'testPracticeList',
		meta: {
			title: '记录',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/testExam/TestPracticeList.vue'], resolve),
	}, {
		path: '/competition',
		name: 'Competition',
		meta: {
			title: '比赛',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/testExam/Competition.vue'], resolve),
	}, {
		path: '/competition-detail',
		name: 'CompetitionDetail',
		meta: {
			title: '比赛详情',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/testExam/CompetitionDetail.vue'], resolve),
	},
	{
		path: '/contest',
		name: 'Contest',
		meta: {
			title: '比赛',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/testExam/Contest.vue'], resolve),
	}, {
		path: '/ranklist',
		name: 'RankList',
		meta: {
			title: '排行榜',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/testExam/RankList.vue'], resolve),
	},
	{
		path: '/homeWorkList',
		name: 'homeWorkList',
		meta: {
			title: '作业',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/testExam/HomeWorkList.vue'], resolve),
	},
	{
		path: '/errorPaperList',
		name: 'errorPaperList',
		meta: {
			title: '错题本',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/testExam/ErrorPaperList.vue'], resolve),
	},
	{
		path: '/aiDrawing',
		name: 'aiDrawing',
		meta: {
			title: 'AI绘画',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/ai/AIDrawing.vue'], resolve),
	},
	{
		path: '/aichat',
		name: 'aichat',
		meta: {
			title: 'AI聊天',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/ai/AIChat.vue'], resolve),
	},
	{
		path: '/personal',
		component: resolve => require(['@/page/view/personal/Index.vue'], resolve),
		meta: {
			title: '个人中心',
			keepAlive: true
		}
	},
	{
		path: '/applyVIP',
		component: resolve => require(['@/page/view/personal/applyVIP.vue'], resolve),
		meta: {
			title: '申请VIP',
			keepAlive: true
		}
	},
	{
		path: '/medal',
		name: 'medal',
		meta: {
			title: '勋章墙',
			keepAlive: false
		},
		component: resolve => require(['@/page/view/medal/MedalWall.vue'], resolve),
	}
];

let routes = [{
		path: '/',
		component: resolve => require(['@/page/view/layout/App.vue'], resolve),
		meta: {
			title: '首页',
			keepAlive: true,
			requireAuth: true
		},
		children: children
	},
	{
		path: '/login',
		name: 'Login',
		meta: {
			title: '后台登录',
			keepAlive: false
		},
		components: {
			blank: resolve => require(['@/page/view/login/Login.vue'], resolve),
		}
	},
	{
		path: '/practice',
		name: 'practice',
		meta: {
			title: '考试中心',
			keepAlive: true
		},
		components: {
			blank: resolve => require(['@/page/view/testExam/Practice.vue'], resolve),
		}
	},
	{
		path: '/practiceDetail',
		name: 'practiceDetail',
		meta: {
			title: '考试中心',
			keepAlive: true
		},
		components: {
			blank: resolve => require(['@/page/view/testExam/PracticeDetail.vue'], resolve),
		}
	},
	{
		path: '/judgeproblem',
		name: 'judgeproblem',
		meta: {
			title: '题目详情',
			keepAlive: true
		},
		components: {
			blank: resolve => require(['@/page/view/judger/JudgeProblem.vue'], resolve),
		}
	},
	// 教师调试页面（无需登录守卫，页面内自行判断）
	{
		path: '/teacher-debug',
		name: 'teacherDebug',
		meta: {
			title: '教师调试',
			keepAlive: false
		},
		components: {
			blank: resolve => require(['@/page/view/judger/TeacherDebug.vue'], resolve),
		}
	},
	{
		path: '/pythonide',
		name: 'pythonide',
		meta: {
			title: 'Python',
			keepAlive: true
		},
		components: {
			blank: resolve => require(['@/page/view/ide/python-ide.vue'], resolve),
		}
	},
	{
		path: '/cppide',
		name: 'cppide',
		meta: {
			title: 'C++',
			keepAlive: true
		},
		components: {
			blank: resolve => require(['@/page/view/ide/cpp-ide.vue'], resolve),
		}
	},
	{
		path: '/scratch',
		name: 'scratch',
		meta: {
			title: 'Scratch',
			keepAlive: true
		},
		components: {
			blank: resolve => require(['@/page/view/ide/scratch-ide.vue'], resolve),
		}
	},
	{
		path: '/typing',
		name: 'typing',
		meta: {
			title: 'typing',
			keepAlive: true
		},
		components: {
			blank: resolve => require(['@/page/view/ide/typing.vue'], resolve),
		}
	},
	{
		path: '/classroom',
		name: 'classroom',
		meta: {
			title: '课堂中心',
			keepAlive: true
		},
		components: {
			blank: resolve => require(['@/page/view/alipreview/classroom.vue'], resolve),
		}
	},
	{
		path: '/onlineClassRoom',
		component: resolve => require(['@/page/view/ide/OnlineClassRoom.vue'], resolve),
		meta: {
			title: '在线课堂',
			keepAlive: true
		}
	}
];

function getUrlToken() {
	let urlStr = location.href.split('?')[1]
	if (urlStr && urlStr.indexOf('token') >= 0) {
		const urlSearchParams = new URLSearchParams(urlStr)
		const result = Object.fromEntries(urlSearchParams.entries())
		return result['token']
	}
	return null;
}
// 页面刷新时，重新赋值token
if (storage.getItem('token')) {
	store.commit(types.SETTOKEN, storage.getItem('token'))
}
// 页面刷新时，重新赋值token
if (getUrlToken()) {
	store.commit(types.SETTOKEN, getUrlToken())
}

var router = new Router({
	mode: 'history'
});
var getDashboard // 获取是否设置过首页面板
var routerCount
var contestUrl = ['/', '/practice', '/login',"/competition-detail"]
router.beforeEach((to, from, next) => {
	window.document.title = Brand.siteName;

	var hostname = window.location.hostname.split('.');

	if (hostname == "contest" && contestUrl.indexOf(to.path) < 0) {
		return;
	}

	if (!getDashboard) {
		getDashboard = store.state.dashboardUrl;
		routerCount = 0;
		routerdashboard(to, next)
	} else if (from.path == '/login' && routerCount <= 1) {
		getDashboard = store.state.dashboardUrl;
		routerCount++
		routerdashboard(to, next)
	} else {
		next()
	}



	if (to.matched.some(r => r.meta.requireAuth)) {
		var validToken = store.getters.token;
		if (!validToken)
			validToken = storage.getItem('token')
		if (validToken) {
			next();
			// http.post('/api/TokenAuth/IsValidToken', {}).then(response => {
			// 	next();
			// })
		} else {
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
		}
	} else {
		next();
	}
})


function routerdashboard(to, next) {
	const newRouter = new Router();
	router.matcher = newRouter.matcher
	var hostname = window.location.hostname.split('.');
	
	router.addRoutes(routes) //动态添加路由
	next({
		...to,
		replace: true
	})
}

// 动态路由
// function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
// 	const accessedRouters = asyncRouterMap.filter(route => {
// 		if (route.component) {
// 			if (route.component === 'Layout') { //Layout组件特殊处理
// 				route.component = Layout
// 			} else {
// 				route.component = import(route.component); //require(route.component) //_import(route.component)
// 			}
// 		}
// 		if (route.children && route.children.length) {
// 			route.children = filterAsyncRouter(route.children)
// 		}
// 		return true
// 	})

// 	return accessedRouters
// }

// function routerGo(to, next) {
// 	getRouter = filterAsyncRouter(getRouter) //过滤路由
// 	router.addRoutes(getRouter) //动态添加路由
// 	next({ ...to,
// 		replace: true
// 	})
// }

// function saveStorage(name, data) { //localStorage 存储数组对象的方法
// 	localStorage.setItem(name, JSON.stringify(data))
// }

// function getStorage(name) { //localStorage 获取数组对象的方法
// 	return JSON.parse(window.localStorage.getItem(name));

// }

export default router;